<template>
  <div class="meta-wrap">
    <b-skeleton width="60%" v-if="$store.getters['auth/isLoadding']">
    </b-skeleton>
    <div v-else class="title">Please connect wallet to quick fight...</div>
    <b-skeleton
      width="200px"
      height="50px"
      v-if="$store.getters['auth/isLoadding']"
    >
    </b-skeleton>
    <b-btn v-else class="btn-connect text-uppercase" @click="onConnect">
      <img class="i-metamask" src="~@/assets/icons/metamask.svg" />
      Connect Wallet
    </b-btn>
  </div>
</template>
<script>
export default {
  methods: {
    onConnect() {
      this.$eventBus.$emit("connect-wallet");
    },
  },
};
</script>
<style lang="scss" scoped>
.meta-wrap {
  border-radius: 2px;
  background: rgba(20, 16, 26, 0.8);
  display: flex;
  padding: 40px 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
  text-align: center;
  // margin: 60px 0;
  margin-top: 0;
  .title {
    color: var(--White, #fff);
    text-align: center;
    font-family: Source Sans Pro;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 158.2%; /* 31.64px */
  }
  .btn-connect {
    display: flex;
    padding: 15px 30px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-bottom: 2px solid var(--Red, #eb345f);
    background: transparent;
    font-size: 18px;
    font-weight: 700;
    &:focus,
    &:active {
      box-shadow: none;
    }
    .i-metamask {
      margin-right: 20px;
    }
  }
}
</style>
